import { useState } from 'react';
import { Collapse } from '@nexelem/deprecated-theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { IconButton } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../../hooks';

type ParameterGroupProps = {
  title: string;
  children: React.ReactNode;
};

export const ParameterGroup = ({ title, children }: ParameterGroupProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { tWrapper } = useCustomTranslation('products.simulationPlan');

  return (
    <div className="overflow-hidden rounded-xs border border-border-container">
      <div
        className="flex cursor-pointer items-center justify-between bg-surface-container-lighter p-2 pl-6"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="text-t16-b">{title || tWrapper('parameters')}</span>
        <IconButton Icon={() => <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />} />
      </div>
      <Collapse in={isExpanded}>
        <div className="grid grid-cols-1 gap-x-10 gap-y-5 border-t border-border-container bg-surface-container p-6 md:grid-cols-[repeat(auto-fit,minmax(40rem,1fr))]">
          {children}
        </div>
      </Collapse>
    </div>
  );
};
